import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { useTranslation } from 'react-i18next';
import useTheme from '../../hooks/useTheme';
import { getStackScreenOptions } from '../config/screenOptions';
import { PurchaseStackParamList } from '../types/navigation.types';
import { createLazyScreen } from '../utils/lazyScreen';

// Lazy load screens
const PurchaseListScreen = createLazyScreen(() => import('../../screens/purchase/purchase-list-screen'));
const PurchaseDetailScreen = createLazyScreen(() => import('../../screens/purchase/purchase-detail-screen'));
const PurchaseEditScreen = createLazyScreen(() => import('../../screens/purchase/purchase-edit-screen'));
const PurchaseExtractionScreen = createLazyScreen(() => import('../../screens/purchase/purchase-extraction-screen'));
const VendorPaymentScreen = createLazyScreen(() => import('../../screens/purchase/vendor-payment-screen'));
const CameraScreen = createLazyScreen(() => import('../../screens/capture/camera-screen'));
const PurchaseOrderListScreen = createLazyScreen(() => import('../../screens/purchase-order/purchase-order-list-screen'));
const PurchaseOrderDetailScreen = createLazyScreen(() => import('../../screens/purchase-order/purchase-order-detail-screen'));
const DeliveryCheckScreen = createLazyScreen(() => import('../../screens/purchase/delivery-check-screen'));

const Stack = createStackNavigator<PurchaseStackParamList>();

export function PurchaseStack() {
  const { t } = useTranslation();
  const { colors } = useTheme();

  return (
    <Stack.Navigator screenOptions={getStackScreenOptions(colors)}>
      <Stack.Screen
        name="PurchaseList"
        component={PurchaseListScreen}
        options={{ title: t('purchase.list', 'Purchase History') }}
      />
      <Stack.Screen
        name="PurchaseDetail"
        component={PurchaseDetailScreen}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name="PurchaseEdit"
        component={PurchaseEditScreen}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name="CapturePurchase"
        component={CameraScreen}
        options={{ title: t('purchase.capture', 'Record Purchase') }}
      />
      <Stack.Screen
        name="PurchaseExtraction"
        component={PurchaseExtractionScreen}
        options={{ title: t('purchase.extraction', 'Purchase Extraction') }}
      />
      <Stack.Screen
        name="VendorPayment"
        component={VendorPaymentScreen}
        options={{ title: t('purchase.vendorPayment', 'Vendor Payment') }}
      />
      <Stack.Screen
        name="PurchaseOrderList"
        component={PurchaseOrderListScreen}
        options={{ title: t('purchaseOrder.list', 'Purchase Orders') }}
      />
      <Stack.Screen
        name="PurchaseOrderDetail"
        component={PurchaseOrderDetailScreen}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name="DeliveryCheck"
        component={DeliveryCheckScreen}
        options={{ 
          title: t('purchase.deliveryCheck', 'Verify Delivery'),
          headerShown: false 
        }}
      />
    </Stack.Navigator>
  );
}